module.exports = __webpack_public_path__ + "img/icon-arrow-background-btn-right.a2460b67.svg";